import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const CaseStudyPageHero = ({ title, backgroundImage }) => {
    const navigate = useNavigate();
    const handlePageLink = (path) => {
        navigate(path);
    };

    return (
        <section className="case-study hero-section d-flex align-items-center justify-content-center" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <Container fluid>
                <div className="content-block mb-3">
                    <h3 className="text-white ft-wt-700 mb-3 text-capitalize cursor-pointer" onClick={() => handlePageLink("/resources/case_study")} >back to case studies</h3>
                    <h2 className="text-white ft-wt-700 mb-5 big-title">{title}</h2>
                    <div>
                        <Button className="text-uppercase" variant="secondary">
                            <h5 className="mb-0 text-primary">Apply for free 2 weeks trial</h5>
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default CaseStudyPageHero;
